export default __webpack_public_path__ + "static/media/card-w-product@3x.c13e473c.png";